import { render } from "./App.vue?vue&type=template&id=3110dc37"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3110dc37&lang=scss"

import exportComponent from "E:\\Project\\Vue\\keep-calm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__